<template>
  <div id="cardMainHis">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>月车</el-breadcrumb-item>
          <el-breadcrumb-item>月车管理</el-breadcrumb-item>
          <el-breadcrumb-item>月卡历史记录</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     @change="changeCust"
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <!--<el-form-item label="月卡分组::">-->
          <!--<el-select v-model="selfGroupID"-->
                     <!--placeholder="请选择分组"-->
                     <!--clearable-->
                     <!--filterable>-->
            <!--<el-option v-for="item in choiceGroups"-->
                       <!--:key="item.fGroupID"-->
                       <!--:label="item.fGroupName"-->
                       <!--:value="item.fGroupID">-->
            <!--</el-option>-->
          <!--</el-select>-->
        <!--</el-form-item>-->
        <el-form-item label="完整卡号::">
          <el-input placeholder="请输入完整卡号"
                    v-model="fCardNo"
                    class="input-with-select">
          </el-input>
        </el-form-item>
        <el-form-item label="车牌关键字::">
          <el-input placeholder="请输入车牌关键字"
                    v-model="fPlateList"
                    class="input-with-select">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="cardQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="cardList"
                border
                v-loading="loading"
                highlight-current-row
                style="width: 100%"
                :height="tableHeight"
                ref="singleTable">
        <el-table-column type="index"
                         width="50"
                         label="序号"
                         :index="indexMethod">
        </el-table-column>
        <el-table-column prop="fOpLastTimeName"
                         width="180"
                         label="最后同步时间">
        </el-table-column>
        <el-table-column prop="fCustNo"
                         width="80"
                         label="客户编号">
        </el-table-column>
        <el-table-column prop="custName"
                         width="200"
                         label="客户名称">
        </el-table-column>
        <el-table-column prop="fCardNo"
                         width="80"
                         label="卡号">
        </el-table-column>
        <el-table-column prop="fGroupName"
                         width="80"
                         label="分组名称">
        </el-table-column>
        <!--<el-table-column-->
        <!--prop="fCustName"-->
        <!--width="80"-->
        <!--label="用户姓名">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
        <!--prop="fCustPhone"-->
        <!--label="用户电话">-->
        <!--</el-table-column>-->
        <el-table-column prop="fCustName"
                         label="用户姓名">
        </el-table-column>
        <el-table-column prop="fPlateList"
                         width="150"
                         label="车牌号码">
        </el-table-column>
        <el-table-column prop="fPlaceNums"
                         align="right"
                         width="80"
                         label="车位数量">
        </el-table-column>
        <el-table-column prop="fCardTypeName"
                         width="80"
                         label="月卡类型">
        </el-table-column>
        <el-table-column prop="fAmount"
                         align="right"
                         label="包月金额">
        </el-table-column>
        <el-table-column prop="fStartTime"
                         width="150"
                         label="起始时间">
        </el-table-column>
        <el-table-column prop="fEndTime"
                         width="150"
                         label="结束时间">
        </el-table-column>
        <el-table-column prop="fCommRateName"
                         width="90"
                         label="普通日费率">
        </el-table-column>
        <el-table-column prop="fHoliRateName"
                         width="90"
                         label="节假日费率">
        </el-table-column>
        <el-table-column prop="fCustInfo"
                         label="用户单位">
        </el-table-column>
        <el-table-column prop="fStopPlace"
                         label="停放位置">
        </el-table-column>
        <el-table-column prop="fRoomNo"
                         label="房间号">
        </el-table-column>
        <el-table-column prop="fRemark"
                         label="备注">
        </el-table-column>
        <el-table-column prop="fOpTypeName"
                         width="80"
                         label="操作类型">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         align="center"
                         width="150">
          <template slot-scope="scope">
            <el-button @click="viewHisCard(scope.row)"
                       type="success"
                       size="mini">查看月卡</el-button>
            <!--<el-button @click="viewCard(scope.row)"-->
                       <!--type="success"-->
                       <!--v-if="is_edit"-->
                       <!--size="mini">查看关联月卡</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="detailTitle"
               :visible.sync="cardEditOrDetailVisible"
               width="55%"
               top="7vh"
               v-dialogDrag>
      <el-tabs v-model="editOrDetail"
               type="card">
        <el-tab-pane label="基本信息"
                     name="cardBaseInfo"
                     style="padding-left: 40px">
          <el-form :model="curRowInfo"
                   class="curRowInfo">
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass"><span class="isRed">*</span>客户名称::</el-col>
              <el-col :span="6">
                <el-select v-model="curRowInfo.fCustID"
                           filterable
                           placeholder="请选择客户"
                           :disabled="!curRowInfo.isEdit||curRowInfo.op=='edit'"
                           @change="changeRowCust"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in choiceCusts"
                             :key="item.fCustID"
                             :label="item.unionName"
                             :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">卡号::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fCardNo"
                          :disabled="!curRowInfo.isEdit"
                          placeholder="若不填写该值，系统默认给最大值"
                          class="myCardInput"
                          style="width: 100%"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass"><span class="isRed">*</span>用户姓名::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fCustName"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass"><span class="isRed">*</span>月卡分组::</el-col>
              <el-col :span="6">
                <el-select v-model="curRowInfo.fGroupID"
                           filterable
                           :disabled="!curRowInfo.isEdit"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in groupList"
                             :key="item.fGroupID"
                             :label="item.fGroupName"
                             :value="item.fGroupID">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">证件号码::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fCustCreNo"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">用户电话::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fCustPhone"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">用户单位::</el-col>
              <el-col :span="16">
                <el-input v-model="curRowInfo.fCustInfo"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass"><span class="isRed">*</span>绑定车牌::</el-col>
              <el-col :span="16">
                <el-input v-model="curRowInfo.fPlateList"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"
                          @blur="plateBlur"></el-input>
              </el-col>
            </el-row>
            <el-row style="margin:0px;">
              <el-col :span="4">&nbsp;</el-col>
              <el-col :span="16">
                <div style="color:red;padding-top: 2px">请输入如果有多个车牌，车牌与车牌之间请用空格分隔</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">停放位置::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fStopPlace"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">房间号::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fRoomNo"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass"><span class="isRed">*</span>月卡类型::</el-col>
              <el-col :span="6">
                <el-select v-model="curRowInfo.fCardTypeID"
                           filterable
                           :disabled="!curRowInfo.isEdit"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in cardTypeList"
                             :key="item.value"
                             :label="item.text"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">车辆类型::</el-col>
              <el-col :span="6">
                <el-select v-model="curRowInfo.fCarTypeID"
                           filterable
                           :disabled="!curRowInfo.isEdit"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in carTypeList"
                             :key="item.value"
                             :label="item.text"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass"><span class="isRed">*</span>起始时间::</el-col>
              <el-col :span="6">
                <el-date-picker v-model="curRowInfo.fStartTime"
                                :disabled="!curRowInfo.isEdit||curRowInfo.op=='edit'"
                                :clearable="false"
                                type="date"
                                placeholder="选择起始时间"
                                style="width:100%"
                                class="cardDateTime">
                </el-date-picker>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass"><span class="isRed">*</span>结束时间::</el-col>
              <el-col :span="6">
                <el-date-picker v-model="curRowInfo.fEndTime"
                                :disabled="!curRowInfo.isEdit||curRowInfo.op=='edit'"
                                :clearable="false"
                                type="date"
                                placeholder="选择结束时间"
                                style="width:100%"
                                class="cardDateTime">
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">普通日费率::</el-col>
              <el-col :span="6">
                <el-select v-model="curRowInfo.fCommRateID"
                           filterable
                           :disabled="!curRowInfo.isEdit"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in cardCommList"
                             :key="item.fRateID"
                             :label="item.fRateName"
                             :value="item.fRateID">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">节假日费率::</el-col>
              <el-col :span="6">
                <el-select v-model="curRowInfo.fHoliRateID"
                           filterable
                           :disabled="!curRowInfo.isEdit"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in cardHoliList"
                             :key="item.fRateID"
                             :label="item.fRateName"
                             :value="item.fRateID">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">进场语音::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fInVocMsg"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">进场LED::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fInLedMsg"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">出场语音::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fOutVocMsg"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">出场LED::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fOutLedMsg"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">备注::</el-col>
              <el-col :span="16">
                <el-input type="textarea"
                          v-model="curRowInfo.fRemark"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">
              </el-col>
              <el-col :span="16">
                <sapn style="color:red;">进场语音，出场语音，进场LED，出场LED可使用 @车牌 变量播报当前进场的车牌号码。</sapn>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="车牌列表"
                     name="cardPlateInfo">
          <el-table :data="cardPlateList"
                    border
                    highlight-current-row
                    style="width: 100%"
                    ref="cardPlateListTable"
                    height="500">
            <el-table-column type="index"
                             width="80"
                             label="序号">
            </el-table-column>
            <el-table-column prop="plateCode"
                             label="车牌号码">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="绑定场库"
                     name="cardParkInfo">
          <el-row>
            <el-table :data="cardBindParkList"
                      border
                      highlight-current-row
                      style="width: 100%"
                      ref="cardBindParkTable"
                      height="450">
              <el-table-column type="index"
                               width="80"
                               label="序号">
              </el-table-column>
              <el-table-column prop="fParkName"
                               label="绑定停车场">
              </el-table-column>
              <el-table-column prop="fPlaceNums"
                               label="车位数量">
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="绑定进出通道"
                     name="cardChnlInfo">
          <el-row>
            <el-col>
              <el-table :data="cardBindChannelListUI"
                        border
                        style="width: 100%;height: 371px"
                        height="448"
                        highlight-current-row
                        @current-change="bindChnlChange">
                <el-table-column type="index"
                                 label="序号"
                                 width="50">
                </el-table-column>
                <el-table-column prop="ParkNameWithChnlName"
                                 label="绑定停车场通道">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-tab-pane>
        <!--<el-tab-pane label="通道白名单"-->
                     <!--name="cardChnlWhiteInfo">-->
          <!--<el-row>-->
            <!--<el-col>-->
              <!--<el-table :data="cardBindWhiteListUI"-->
                        <!--border-->
                        <!--style="width: 100%;height: 371px"-->
                        <!--height="448"-->
                        <!--highlight-current-row-->
                        <!--@current-change="bindWhiteChnlChange">-->
                <!--<el-table-column type="index"-->
                                 <!--label="序号"-->
                                 <!--width="50">-->
                <!--</el-table-column>-->
                <!--<el-table-column prop="ParkNameWithChnlName"-->
                                 <!--label="白名单通道">-->
                <!--</el-table-column>-->
              <!--</el-table>-->
            <!--</el-col>-->
          <!--</el-row>-->
        <!--</el-tab-pane>-->
        <!--<el-tab-pane label="续费记录"-->
                     <!--name="cardFeeList">-->
          <!--<el-row>-->
            <!--<el-table :data="feeRecordList"-->
                      <!--border-->
                      <!--highlight-current-row-->
                      <!--style="width: 100%"-->
                      <!--height="500">-->
              <!--<el-table-column type="index"-->
                               <!--width="50"-->
                               <!--label="序号">-->
              <!--</el-table-column>-->
              <!--<el-table-column prop="OpLastTime"-->
                               <!--width="150"-->
                               <!--label="续费时间">-->
              <!--</el-table-column>-->
              <!--<el-table-column prop="CardTypeName"-->
                               <!--label="月卡类型">-->
              <!--</el-table-column>-->
              <!--<el-table-column prop="BatStartTime"-->
                               <!--label="起始时间"-->
                               <!--width="150">-->
              <!--</el-table-column>-->
              <!--<el-table-column prop="BatEndTime"-->
                               <!--label="结束时间"-->
                               <!--width="150">-->
              <!--</el-table-column>-->
              <!--<el-table-column prop="fPayAmount"-->
                               <!--align="right"-->
                               <!--label="金额">-->
              <!--</el-table-column>-->
              <!--<el-table-column prop="nHours"-->
                               <!--align="right"-->
                               <!--label="时间（小时）">-->
              <!--</el-table-column>-->
              <!--<el-table-column prop="fRemark"-->
                               <!--label="备注">-->
              <!--</el-table-column>-->
              <!--&lt;!&ndash; <el-table-column fixed="right"-->
                                   <!--align="center"-->
                                   <!--label="操作">-->
                    <!--<template slot-scope="scope">-->
                      <!--<el-button size="mini"-->
                                 <!--type="danger"-->
                                 <!--v-if="scope.row.fBigRowID === '-1'"-->
                                 <!--@click="deleteNewPay(scope.$index, scope.row)">删除</el-button>-->
                    <!--</template>-->
                  <!--</el-table-column> &ndash;&gt;-->
            <!--</el-table>-->
          <!--</el-row>-->
          <!--&lt;!&ndash; <el-row>-->
                <!--<el-col :span="4"-->
                        <!--class="el-form-item__label myCardLableClass">卡号::</el-col>-->
                <!--<el-col :span="6">-->
                  <!--<el-input v-model="curRowInfo.fCardNo"-->
                            <!--:disabled="disabledFlage"-->
                            <!--class="myCardInput"-->
                            <!--style="width: 100%"></el-input>-->
                <!--</el-col>-->
                <!--<el-col :span="4"-->
                        <!--class="el-form-item__label myCardLableClass">用户姓名::</el-col>-->
                <!--<el-col :span="6">-->
                  <!--<el-input v-model="curRowInfo.fCustName"-->
                            <!--:disabled="disabledFlage"-->
                            <!--class="myCardInput"-->
                            <!--style="width: 100%"></el-input>-->
                <!--</el-col>-->
              <!--</el-row>-->
              <!--<el-row>-->
                <!--<el-col :span="4"-->
                        <!--class="el-form-item__label myCardLableClass">绑定车牌::</el-col>-->
                <!--<el-col :span="6">-->
                  <!--<el-input v-model="curRowInfo.fPlateList"-->
                            <!--:disabled="disabledFlage"-->
                            <!--class="myCardInput"-->
                            <!--style="width: 100%"></el-input>-->
                <!--</el-col>-->
                <!--<el-col :span="4"-->
                        <!--class="el-form-item__label myCardLableClass">月卡类型::</el-col>-->
                <!--<el-col :span="6">-->
                  <!--<el-input v-model="curRowInfo.fCardTypeName"-->
                            <!--:disabled="disabledFlage"-->
                            <!--class="myCardInput"-->
                            <!--style="width: 100%"></el-input>-->
                <!--</el-col>-->
              <!--</el-row>-->
              <!--<el-row>-->
                <!--<el-col :span="4"-->
                        <!--class="el-form-item__label myCardLableClass">金额(元)::</el-col>-->
                <!--<el-col :span="6">-->
                  <!--<el-input v-model="cardPay.fPayAmount"-->
                            <!--:disabled="!curRowInfo.isEdit"-->
                            <!--class="myCardInput"-->
                            <!--style="width: 100%"></el-input>-->
                <!--</el-col>-->
                <!--<el-col :span="4"-->
                        <!--class="el-form-item__label myCardLableClass"-->
                        <!--v-if="curRowInfo.fCardTypeID === '40'">购买时间(小时)::</el-col>-->
                <!--<el-col :span="6"-->
                        <!--v-if="curRowInfo.fCardTypeID === '40'">-->
                  <!--<el-input v-model="cardPay.fPaySecs"-->
                            <!--:disabled="!curRowInfo.isEdit"-->
                            <!--class="myCardInput"-->
                            <!--style="width: 100%"></el-input>-->
                <!--</el-col>-->
              <!--</el-row>-->
              <!--<el-row>-->
                <!--<el-col :span="4"-->
                        <!--class="el-form-item__label myCardLableClass">起始时间::</el-col>-->
                <!--<el-col :span="6"-->
                        <!--style="margin-top: 9px">-->
                  <!--<el-date-picker v-model="cardPay.fBatStartTime"-->
                                  <!--:disabled="!curRowInfo.isEdit"-->
                                  <!--type="date"-->
                                  <!--placeholder="选择起始时间"-->
                                  <!--class="cardDateTime"-->
                                  <!--value-format="yyyy-MM-dd">-->
                  <!--</el-date-picker>-->
                <!--</el-col>-->
                <!--<el-col :span="4"-->
                        <!--class="el-form-item__label myCardLableClass">结束时间::</el-col>-->
                <!--<el-col :span="6"-->
                        <!--style="margin-top: 9px">-->
                  <!--<el-date-picker v-model="cardPay.fBatEndTime"-->
                                  <!--:disabled="!curRowInfo.isEdit"-->
                                  <!--type="date"-->
                                  <!--placeholder="选择结束时间"-->
                                  <!--class="cardDateTime"-->
                                  <!--value-format="yyyy-MM-dd">-->
                  <!--</el-date-picker>-->
                <!--</el-col>-->
              <!--</el-row>-->
              <!--<el-row>-->
                <!--<el-col :span="4"-->
                        <!--class="el-form-item__label myCardLableClass">备注::</el-col>-->
                <!--<el-col :span="12">-->
                  <!--<el-input type="textarea"-->
                            <!--v-model="cardPay.fRemark"-->
                            <!--:disabled="!curRowInfo.isEdit"-->
                            <!--class="myCardInput"></el-input>-->
                <!--</el-col>-->
                <!--<el-col :span="4"-->
                        <!--class="el-form-item__label myCardLableClass"-->
                        <!--style="padding-top: 5px;padding-right: 40px">-->
                  <!--<el-button type="warning"-->
                             <!--:disabled="!curRowInfo.isEdit"-->
                             <!--icon="el-icon-circle-plus"-->
                             <!--size="small"-->
                             <!--@click="cardPayClick">续费</el-button>-->
                <!--</el-col>-->
              <!--</el-row> &ndash;&gt;-->
        <!--</el-tab-pane>-->
      </el-tabs>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="cardEditOrDetailVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import carInfoView from '../../components/carInfoView'
import * as api from '../../api/card'
import $ from 'jquery'
import { mapActions } from 'vuex'
export default {
  name: 'cardMainHis',
  // components: { carInfoView },
  data () {
    return {
      fCardNo: '',
      fPlateList: '',
      is_edit: false,
      is_del: false,
      is_syn: false,
      is_all_syn: false,
      is_batch_syn: false,
      is_export: false,
      is_import: false,
      disabledFlage: true,
      importDataVisible: false,
      synDataVisible: false,
      statusTitle: '',
      export_msg: '导出',
      download_loading: false,
      export_loading: false,
      save_loading: false,
      sync_loading: false,
      sync_msg: '下发',
      save_msg: '保存',
      rightWhiteChnl: {},
      leftWhiteChnl: {},
      rightChnl: {},
      leftChnl: {},
      choiceParks: [],
      groupList: [],
      cardPayList: [],
      selfParkID: '',
      fPlaceNums: '',
      navigationMap: {
        cardList: '月卡列表',
        synCardList: '待同步'
      },
      importModel: {
        fCustID: '',
        data: [],
        loading: false,
        btnMsg: '点击上传',
        btnLoading: false,
        btnOkDisabled: true,
        btnOkMsg: '确定导入',
        btnOkLoading: false
      },
      cardActiveName: 'cardList',
      fCustName: '',
      loading: false,
      searchKeyWord: '',
      feeRecordList: [],
      cardUnBindWhiteName: '',
      cardUnBindWhiteList: [],
      cardUnBindWhiteListUI: [],
      cardBindWhiteName: '',
      cardBindWhiteList: [],
      cardBindWhiteListUI: [],
      bindChannelName: '',
      cardBindChannelList: [],
      cardBindChannelListUI: [],
      unbindChannelName: '',
      cardUnBindChannelList: [],
      cardUnBindChannelListUI: [],
      cardBindParkList: [],
      cardTypeListDefaultValue: '',
      cardTypeList: [],
      carTypeListDefaultValue: '',
      carTypeList: [],
      cardHoliList: [],
      cardCommList: [],
      cardPlateList: [],
      carPresentList: [],
      curRowInfo: {
        fCustID: '',
        fCardNo: '',
        fCustName: '',
        fGroupID: '',
        fCustCreNo: '',
        fCustPhone: '',
        fCustInfo: '',
        fPlateList: '',
        fStopPlace: '',
        fRoomNo: '',
        fCardTypeID: '',
        fCarTypeID: '',
        fCardTypeName: '',
        fStartTime: '',
        fEndTime: '',
        fCommRateID: '',
        fHoliRateID: '',
        fInVocMsg: '',
        fInLedMsg: '',
        fOutVocMsg: '',
        fOutLedMsg: '',
        fRemark: '',
        isEdit: false,
        fCardAmount: 0,
        fCardSecs: 0,
        fStatus: 0
      },
      cardPay: {
        fBigRowID: '-1',
        fPayAmount: 0,
        fPaySecs: 0,
        fCardTypeID: 0,
        fBatStartTime: '',
        fBatEndTime: '',
        fRemark: ''
      },
      editOrDetail: 'cardBaseInfo',
      detailTitle: '',
      cardEditOrDetailVisible: false,
      tableHeight: 0,
      choiceCusts: [],
      offlineCusts: [],
      choiceGroups: [],
      cardList: [],
      synCardList: [],
      selCustID: '',
      selfGroupID: '',
      pageSize: 20,
      pageNo: 1,
      total: 0,
      syncData: {
        isAll: false,
        tip: '',
        title: '',
        fCustID: ''
      },
      rules: {
        fCustID: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    ...mapActions([
      'getCardGroupByCustId', 'getCustByGroup', 'getCardByQuery', 'loadCardOtherList', 'getParkList', 'saveCard', 'getCurrentUserPers', 'cardDataTemplate',
      'deleteCard', 'synCardById', 'setCardStatus', 'loadCardTypeList', 'loadCarTypeList', 'getRechargeList', 'getCardPayList', 'getCarPresnetList', 'cardUpload', 'importCardData', 'exportCardData'
    ]),
    uploadSuccess (response, file, fileList) {
      console.log('file upload success')
    },
    changeImportCust (fCustID) {
      this.importModel.data = []
      this.importModel.btnOkDisabled = true
    },
    exportData () {
      if ((this.selCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      this.exportCardData({
        fCustID: this.selCustID,
        fGroupID: this.selfGroupID,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        searchKeyWord: this.searchKeyWord,
        cardActiveName: this.cardActiveName
      }).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_月卡数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    handleInfo (row, column, event) {
      this.$refs.child.handleInfo(row)
    },
    setImgHeight () {
      var formHeight = $('.form_right').height()
      var fplateHeight = $('.fplate_info .el-image').height()
      var carImgHeight = $('.car_img .img').height()
      if (formHeight && fplateHeight > 0) {
        var height = (formHeight - fplateHeight - carImgHeight) / 2
        $('.fplate_info').css({ 'margin-top': height + 'px', 'margin-bottom': height + 'px' })
      }
    },
    unbindChnlChange (chnl) {
      this.rightChnl = chnl
    },
    bindChnlChange (chnl) {
      this.leftChnl = chnl
    },
    unbindWhiteChnlChange (chnl) {
      this.rightWhiteChnl = chnl
    },
    bindWhiteChnlChange (chnl) {
      this.leftWhiteChnl = chnl
    },
    leftChnlBtnClick () {
      if (!this.rightChnl || !this.rightChnl.fParkID || !this.rightChnl.fChnlID) {
        return
      }
      this.cardBindChannelList.push(this.rightChnl)
      this.cardBindChannelListUI.push(this.rightChnl)
      this.cardUnBindChannelListUI.splice(this.cardUnBindChannelListUI.indexOf(this.rightChnl), 1)
      this.cardUnBindChannelList.splice(this.cardUnBindChannelList.indexOf(this.rightChnl), 1)
    },
    rightChnlBtnClick () {
      if (!this.leftChnl || !this.leftChnl.fParkID || !this.leftChnl.fChnlID) {
        return
      }
      this.cardUnBindChannelList.push(this.leftChnl)
      this.cardUnBindChannelListUI.push(this.leftChnl)
      this.cardBindChannelListUI.splice(this.cardBindChannelListUI.indexOf(this.leftChnl), 1)
      this.cardBindChannelList.splice(this.cardBindChannelList.indexOf(this.leftChnl), 1)
    },
    leftWhiteBtnClick () {
      if (!this.rightWhiteChnl || !this.rightWhiteChnl.fParkID || !this.rightWhiteChnl.fChnlID) {
        return
      }
      this.cardBindWhiteList.push(this.rightWhiteChnl)
      this.cardBindWhiteListUI.push(this.rightWhiteChnl)
      this.cardUnBindWhiteListUI.splice(this.cardUnBindWhiteListUI.indexOf(this.rightWhiteChnl), 1)
      this.cardUnBindWhiteList.splice(this.cardUnBindWhiteList.indexOf(this.rightWhiteChnl), 1)
    },
    rightWhiteBtnClick () {
      if (!this.leftWhiteChnl || !this.leftWhiteChnl.fParkID || !this.leftWhiteChnl.fChnlID) {
        return
      }
      this.cardUnBindWhiteList.push(this.leftWhiteChnl)
      this.cardUnBindWhiteListUI.push(this.leftWhiteChnl)
      this.cardBindWhiteListUI.splice(this.cardBindWhiteListUI.indexOf(this.leftWhiteChnl), 1)
      this.cardBindWhiteList.splice(this.cardBindWhiteList.indexOf(this.leftWhiteChnl), 1)
    },
    deleteBindPark (index, row) {
      // let index2 = this.cardBindParkList.indexOf(row)
      this.$confirm('请确认是否删除【' + row.fParkName + '】停车场车位数据', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.cardBindParkList.splice(index, 1)
      }).catch(() => { })
    },
    addPark (fPark) {
      var bindPark = this.cardBindParkList.filter(item => {
        if (item.fParkID === fPark.fParkID) { return item }
      })
      if (bindPark && bindPark.length > 0) {
        bindPark[0].fPlaceNums = this.fPlaceNums
      } else {
        let bindParkObject = {}
        bindParkObject.fParkName = fPark.fParkName
        bindParkObject.fParkID = fPark.fParkID
        bindParkObject.fPlaceNums = this.fPlaceNums
        this.cardBindParkList.push(bindParkObject)
      }
    },
    bindPark () {
      if ((this.selfParkID || '').trim().length <= 0) {
        this.$message.error('请选择场库')
        return
      }
      if (this.validationNegative(this.fPlaceNums)) {
        this.$message.error('车位数量请输入数字')
        return
      }
      if (this.selfParkID === '0') {
        for (let i = 1; i < this.choiceParks.length; i++) {
          this.addPark(this.choiceParks[i])
        }
      } else {
        let tmpParks = this.choiceParks.filter(item => {
          if (item.fParkID === this.selfParkID) { return item }
        })
        this.addPark(tmpParks[0])
      }
    },
    validationNegative (number) {
      var reg = /^[0-9]*[1-9][0-9]*$/
      if (!reg.test(number)) {
        return true
      } else {
        return false
      }
    },
    isfloat (str) {
      for (var i = 0; i < str.length; i++) {
        if ((str.charAt(i) < '0' || str.charAt(i) > '9') && str.charAt(i) !== '.') {
          return false
        }
      }
      return true
    },
    tabClick () {
      this.pageNo = 1
      this.total = 0
      this.initData()
    },
    cardQuery () {
      this.initData()
      // let obj = {}
      // obj = this.choiceCusts.find((item) => {
      //   return item.fCustID === this.selCustID
      // })
      // this.custName = obj.unionName
    },
    bindParkQuery () {
      let tmp = this.bindChannelName.trim().toLowerCase()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.cardBindChannelListUI = this.copyArr(this.cardBindChannelList)
        return
      }
      this.cardBindChannelListUI = this.cardBindChannelList.filter(r => r.ParkNameWithChnlName.toLowerCase().indexOf(tmp) > -1)
    },
    unbindParkQuery () {
      let tmp = this.unbindChannelName.trim().toLowerCase()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.cardUnBindChannelListUI = this.copyArr(this.cardUnBindChannelList)
        return
      }
      this.cardUnBindChannelListUI = this.cardUnBindChannelList.filter(r => r.ParkNameWithChnlName.toLowerCase().indexOf(tmp) > -1)
    },
    bindWhiteQuery () {
      let tmp = this.cardBindWhiteName.trim().toLowerCase()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.cardBindWhiteListUI = this.copyArr(this.cardBindWhiteList)
        return
      }
      this.cardBindWhiteListUI = this.cardBindWhiteList.filter(r => r.ParkNameWithChnlName.toLowerCase().indexOf(tmp) > -1)
    },
    unbindWhiteQuery () {
      let tmp = this.cardUnBindWhiteName.trim().toLowerCase()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.cardUnBindWhiteListUI = this.copyArr(this.cardUnBindWhiteList)
        return
      }
      this.cardUnBindWhiteListUI = this.cardUnBindWhiteList.filter(r => r.ParkNameWithChnlName.toLowerCase().indexOf(tmp) > -1)
    },
    viewCard (row) {
      this.editOrDetail = 'cardBaseInfo'
      this.setDefault()
      this.curRowInfo.isEdit = false
      var _this = this
      if (row && row !== null && typeof (row) !== 'undefined') {
        api.getCardById({ fCardID: row.fOrgCardID, fCustID: row.fCustID }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              _this.setData(row.fCustID, row.fOrgCardID, row.fCardTypeID, '1')
              Object.assign(_this.curRowInfo, data.Data)
              _this.fCustName = row.custName
              _this.detailTitle = '【' + row.custName + '】' + row.fCardNo + ((row.fPlateList || '').trim().length > 0 ? ('-' + row.fPlateList) : '')
              _this.cardEditOrDetailVisible = true
            } else {
              _this.$message.error('提示：加载月卡信息失败')
            }
          }
        })
      }
    },
    viewHisCard (row) {
      this.editOrDetail = 'cardBaseInfo'
      this.setDefault()
      this.curRowInfo.isEdit = false
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.setData(row.fCustID, row.fCardID, row.fCardTypeID, '0')
        // this.setPark(row.fCustID)
        Object.assign(this.curRowInfo, row)
        this.fCustName = row.custName
        this.detailTitle = '【历史记录：' + row.custName + '】' + row.fCardNo + ((row.fPlateList || '').trim().length > 0 ? ('-' + row.fPlateList) : '')
        this.cardEditOrDetailVisible = true
      }
    },
    setDefault () {
      this.cardBindWhiteList = []
      this.cardUnBindWhiteList = []
      this.cardBindChannelListUI = []
      this.cardBindChannelList = []
      this.cardUnBindChannelList = []
      this.cardBindParkList = []
      this.choiceParks = []
      this.cardPlateList = []
      this.groupList = []
      this.feeRecordList = []
      this.cardPayList = []
      this.carPresentList = []
      this.selfParkID = ''
      this.fPlaceNums = ''
      this.bindChannelName = ''
      this.unbindChannelName = ''
      this.cardBindWhiteName = ''
      this.cardUnBindWhiteName = ''
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = ''
      }
      this.cardPay.fCardTypeID = 0
      this.cardPay.fBigRowID = '-1'
      this.cardPay.fPayAmount = 0
      this.cardPay.fPaySecs = 0
      this.cardPay.fBatStartTime = ''
      this.cardPay.fBatEndTime = ''
      this.cardPay.fRemark = ''
      this.curRowInfo.fCardAmount = 0
      this.curRowInfo.fCardSecs = 0
      this.cardCommList = [{ fRateID: '0', fRateName: '无' }]
      this.cardHoliList = [{ fRateID: '0', fRateName: '无' }]
      this.curRowInfo.fCardTypeID = this.cardTypeListDefaultValue
      this.curRowInfo.fCarTypeID = this.carTypeListDefaultValue
      this.curRowInfo.fCommRateID = '0'
      this.curRowInfo.fHoliRateID = '0'
      var today = new Date()
      this.curRowInfo.fStartTime = new Date()
      this.curRowInfo.fEndTime = new Date(today.setMonth(today.getMonth() + 1))
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
      this.setImgHeight()
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    tableErrorRowClassName ({ row, rowIndex }) {
      if (row.fIsErr) {
        return 'error-row'
      }
      return ''
    },
    initData () {
      var isSyn = this.cardActiveName === 'synCardList'
      if (isSyn) {
        this.synCardList = []
      } else {
        this.cardList = []
      }
      this.loading = true
      api.getCardHisByQuery({
        fCustID: this.selCustID,
        fGroupID: this.selfGroupID,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        searchKeyWord: this.searchKeyWord,
        cardActiveName: this.cardActiveName,
        fPlateList: this.fPlateList,
        fCardNo: this.fCardNo
      }).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.total = data.Data.total
              if (isSyn) {
                this.synCardList = data.Data.rows
              } else {
                this.cardList = data.Data.rows
              }
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    copyArr (arr) { // 深层copy
      let res = []
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i])
      }
      return res
    },
    setData (fCustID, fCardID, fCardTypeID, isHis) {
      this.cardBindParkList = []
      this.cardUnBindChannelList = []
      this.cardUnBindChannelListUI = []
      this.cardBindChannelList = []
      this.cardBindChannelListUI = []
      this.cardBindWhiteList = []
      this.cardBindWhiteListUI = []
      this.cardUnBindWhiteList = []
      this.cardUnBindWhiteListUI = []
      this.feeRecordList = []
      this.cardPayList = []
      this.carPresentList = []
      this.cardHoliList = [{ fRateID: '0', fRateName: '无' }]
      this.cardCommList = [{ fRateID: '0', fRateName: '无' }]
      this.curRowInfo.fCommRateID = '0'
      this.curRowInfo.fHoliRateID = '0'
      this.fPlaceNums = ''
      this.bindChannelName = ''
      this.unbindChannelName = ''
      this.cardBindWhiteName = ''
      this.cardUnBindWhiteName = ''
      this.curRowInfo.fGroupID = ''

      this.groupList = []
      let param = {}
      param.fCustID = fCustID
      param.fCardID = fCardID
      param.fIsSyn = this.cardActiveName === 'synCardList'
      var funLoadCard = this.loadCardOtherList
      var funGetRech = this.getRechargeList
      if (isHis === '0') {
        funLoadCard = api.loadCardHisOtherList
        funGetRech = api.getRechargeHisList
      }
      funLoadCard(param).then(res => {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            (data.Data.cardHoliList || []).forEach(item => {
              this.cardHoliList.push(item)
            });
            (data.Data.cardCommList || []).forEach(item => {
              this.cardCommList.push(item)
            })
            // Object.assign(this.cardHoliList, data.Data.cardHoliList)
            // Object.assign(this.cardCommList, data.Data.cardCommList)
            this.cardBindParkList = Object.assign([], data.Data.cardBindParkList)
            this.cardUnBindChannelList = Object.assign([], data.Data.cardUnBindChannelList)
            this.cardUnBindChannelListUI = this.copyArr(this.cardUnBindChannelList)
            this.cardBindChannelList = Object.assign([], data.Data.cardBindChannelList)
            this.cardBindChannelListUI = this.copyArr(this.cardBindChannelList)
            this.cardBindWhiteList = Object.assign([], data.Data.cardBindWhiteList)
            this.cardBindWhiteListUI = this.copyArr(this.cardBindWhiteList)
            this.cardUnBindWhiteList = Object.assign([], data.Data.cardUnBindWhiteList)
            this.cardUnBindWhiteListUI = this.copyArr(this.cardUnBindWhiteList)
            // this.feeRecordList = data.Data.feeRecordList || []

            this.groupList = data.Data.groups || []
          }
        }
      })
      if (fCustID && fCardID) {
        funGetRech({ fCardID: fCardID, fCustID: fCustID, isSyn: this.cardActiveName === 'synCardList' }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.feeRecordList = data.Data
            } else {
              this.$message.error('提示：加载月卡续费列表信息失败')
            }
          }
        })
      }
    },
    setPark (val) {
      this.choiceParks = []
      this.selfParkID = ''
      this.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let tmpParks = []
              Object.assign(tmpParks, data.Data)
              this.choiceParks = tmpParks
              if (this.choiceParks && this.choiceParks.length > 0) {
                this.choiceParks.splice(0, 0, { fParkID: '0', fParkName: '全部' })
                this.selfParkID = this.choiceParks[0].fParkID
              }
            }
          }
        }
      })
    },
    changeCust (fCustID) {
      this.selfGroupID = ''
      this.choiceGroups = []
      this.getCardGroupByCustId({ fCustID: fCustID }).then(res => {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let tmpGroups = []
            Object.assign(tmpGroups, data.Data)
            this.choiceGroups = tmpGroups
          }
        }
      })
    },
    changeRowCust (fCustID) {
      this.setData(fCustID, 0, 0)
      this.setPark(fCustID)
      // if (this.curRowInfo.op === 'add') {
      //   api.getCardNo({ fCustID: fCustID }).then((res) => {
      //     let { status, data } = res
      //     if (status === 200) {
      //       if (data.IsOk) {
      //         this.curRowInfo.fCardNo = data.Data
      //       }
      //     }
      //   })
      // }
    },
    plateBlur () {
      if ((this.curRowInfo.fPlateList || '').trim().length > 0) {
        var plateList = (this.curRowInfo.fPlateList || '').trim().split(' ')
        var strPlateList = ''
        for (var i = 0; i < plateList.length; i++) {
          var plate = plateList[i].replace(/\s*/g, '')
          if (strPlateList.indexOf(plate) < 0) {
            strPlateList += plate + ' '
          }
          this.curRowInfo.fPlateList = strPlateList
        }
      }
    }
  },
  watch: {
    'curRowInfo.fPlateList' (newValue, oldValue) {
      this.cardPlateList = []
      if ((this.curRowInfo.fPlateList || '').trim().length > 0) {
        var plateList = (this.curRowInfo.fPlateList || '').trim().split(' ')
        for (var i = 0; i < plateList.length; i++) {
          let tmpPlate = {}
          tmpPlate.plateCode = plateList[i]
          this.cardPlateList.push(tmpPlate)
        }
      }
      if (this.curRowInfo.op === 'edit') {
        this.detailTitle = '【' + this.fCustName + '】' + this.curRowInfo.fCardNo + ((this.curRowInfo.fPlateList || '').trim().length > 0 ? ('-' + this.curRowInfo.fPlateList) : '')
      }
    },
    'curRowInfo.fCardNo' () {
      if (this.curRowInfo.op === 'edit') {
        this.detailTitle = '【' + this.fCustName + '】' + this.curRowInfo.fCardNo + ((this.curRowInfo.fPlateList || '').trim().length > 0 ? ('-' + this.curRowInfo.fPlateList) : '')
      }
    },
    'curRowInfo.fCardTypeID' () {
      let tmpTypes = this.cardTypeList.filter(item => {
        if (item.value === this.curRowInfo.fCardTypeID) { return item }
      })
      if (tmpTypes && tmpTypes.length > 0) {
        this.curRowInfo.fCardTypeName = tmpTypes[0].text
      }
    }
  },
  computed: {
    ispagination: function () {
      return this.total > this.pageSize
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 900000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.getCustByGroup().then(res => {
      if (res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.changeCust(this.selCustID)
            }
            this.offlineCusts = custs.filter(r => r.fCustTypeID === '0') // 封闭式客户
          }
        }
      }
    })
    // this.initData()
    this.loadCardTypeList().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.cardTypeListDefaultValue = data.Data.cardTypeListDefaultValue || ''
            this.cardTypeList = data.Data.cardTypeList || []
          }
        }
      }
    })
    this.loadCarTypeList().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.carTypeListDefaultValue = data.Data.carTypeListDefaultValue || ''
            this.carTypeList = data.Data.carTypeList || []
          }
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
  #cardMainHis .is-disabled .el-input__inner,
  #cardMainHis .is-disabled .el-textarea__inner {
    color: #606266;
  }
  #cardMainHis .el-dialog__headerbtn {
    top: 10px;
    font-size: 20px;
  }
  #cardMainHis .el-dialog__title {
    color: white;
  }
  #cardMainHis .el-dialog__header {
    background-color: #337ab7;
    padding: 10px;
  }
  #cardMainHis .el-dialog__body {
    padding: 5px;
  }
  #cardMainHis .warning-row {
    color: chocolate;
  }
  #cardMainHis .error-row {
    color: #fb4545;
  }
</style>
<style scoped>
  .myCardLableClass .isRed {
    color: #fb4545;
  }
  .pageSearch .el-form-item {
    margin-bottom: 5px;
  }
  .curRowInfo {
    margin-top: 10px;
  }
  .curRowInfo .el-row {
    margin-top: 10px;
  }
  .dialog-video-wrapper .el-dialog__body {
    padding: 5px;
  }
  .myel-input__inner {
    height: 20px;
    line-height: 20px;
  }
  legend {
    display: block;
    width: 100%;
    padding: 0;
    margin-bottom: 10px;
    line-height: inherit;
    color: #333;
    border: 0;
    border-bottom: 1px solid #e5e5e5;
  }
  fieldset {
    margin: 0 2px;
    border: 0px solid silver;
  }
  .el-upload__tip {
    margin-top: 0px;
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/view/card/cardMainHis.vue